import React, {useRef, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { gsap } from 'gsap';
import { useGSAP } from "@gsap/react";




const Footer = () => {


const footer_ref = useRef();


useGSAP(() => {


















  }, { scope: footer_ref }); 












  return (
    
    <footer className="site-footer" ref={footer_ref}>

<div className="footer-bg-layer"></div>

<div className="columns">   
<div className="sect-1">
<div className="footer-cta-wrap"><NavLink className="footer-nav-link" to="/contact">Get a Quote</NavLink></div>
</div>   
<div className="sect-2">
  <strong>Follow on Social</strong>

  
  <ul className="social-links">
				<li><a href="https://www.instagram.com/markhawkinsdesigns/" target="_blank">					
          <svg className="social-link" version="1.1"  x="0px" y="0px" viewBox="0 0 100 100">
<g>
	<path d="M50.1,58.4c4.1,0,7.8-3.4,8-7.6c0.3-5.6-4.5-9.1-9.3-8.5c-3.5,0.5-6.1,2.9-6.8,6.4
		C40.9,54.2,45.6,58.4,50.1,58.4z"/>
	<path d="M71.3,26.6H65c-0.9,0-1.6,0.7-1.6,1.6v6.3c0,0.9,0.7,1.6,1.6,1.6h6.3c0.9,0,1.6-0.7,1.6-1.6v-6.3
		C73,27.3,72.2,26.6,71.3,26.6z"/>
	<path d="M50,0C22.4,0,0,22.4,0,50s22.4,50,50,50s50-22.4,50-50S77.6,0,50,0z M78.1,65.2c0,3.8-0.7,6.7-2.7,9
		c-1.8,2-4.2,3.7-7.6,4c-5.6,0.4-11.6,0-17.6,0c-5.7,0-11.8,0.4-17.6,0c-5.7-0.4-10.1-4.6-10.5-10.5c-0.6-7.8,0.4-17,0-25.4
		c0-0.2,0.1-0.4,0.3-0.4c5.3,0,10.5,0,15.8,0c0.5,0.3-0.4,1-0.7,1.5c-1.1,2-1.9,5-1.6,8.3c0.4,6.6,6,12.3,13.1,12.8
		c5.2,0.4,9.4-2.1,12-5.3c2.4-2.9,4.4-8,2.6-13.4c-0.2-0.7-0.6-1.4-1-2c-0.3-0.6-0.8-1.2-0.8-1.9c5.4,0,10.7,0,16.1,0
		C78.2,50.1,78.1,57.6,78.1,65.2z M39,50.5c-0.1-3.6,1.6-6.5,3.3-8.2s3.8-2.8,7.1-3c6.1-0.4,11.1,3.9,11.7,9.5
		c0.6,6.2-3.7,11.7-9.3,12.4c-1,0.1-2.4,0.1-3.4,0C43.5,60.7,39.1,56.2,39,50.5z M78.1,40.3c-4.5,0-8.6,0-13.2,0
		c-1.4,0-3.1,0.3-4.4,0c-0.8-0.2-1.2-1-1.9-1.5c-2.2-1.6-5.6-3-9.8-2.7c-3.1,0.2-5.2,1.3-7.2,2.9c-0.5,0.4-1.3,1.2-1.9,1.4
		c-1.2,0.3-3,0-4.5,0c-4.3,0-8.5,0-13.1,0c0.2-3.3-0.4-6.5,0.1-9.3c0.6-3.3,2.6-5.6,4.6-7c0,3.9,0,11.7,0,11.7H29
		c0,0-0.2-9,0.1-13.1c0.3-0.3,1-0.2,1.4-0.5c0.3,4.2,0.3,13.6,0.3,13.6H33c0,0,0-9,0-13.5c0-0.2,0-0.4,0.1-0.4c0.5,0,0.9,0,1.4,0
		c0,4.6,0,13.9,0,13.9h2.3c0,0,0-9.3,0-13.9c9.4,0.5,21.5-0.6,30.7,0c3.6,0.2,6.6,2,8.3,4.2C78.3,29.3,78.2,34,78.1,40.3z"/>
</g>
</svg>
			</a>
      </li>	
			<li>
        <a href="https://www.behance.net/info8c315552" target="_blank">
        <svg className="social-link" version="1.1" x="0px" y="0px" viewBox="0 0 100 100">
	<g>
		<path d="M39.9,44.6c1-0.8,1.5-2,1.5-3.7c0-1-0.2-1.7-0.5-2.3s-0.8-1.1-1.4-1.4c-0.6-0.3-1.2-0.6-2-0.7
			c-0.7-0.1-1.5-0.2-2.3-0.2h-8.4v9.5h9.1C37.5,45.7,38.8,45.3,39.9,44.6z"/>
		<path d="M41.3,53.2c-1.2-0.9-2.7-1.3-4.7-1.3h-9.8v11.2h9.6c0.9,0,1.7-0.1,2.5-0.3s1.5-0.5,2.1-0.9s1.1-0.9,1.5-1.6
			c0.4-0.7,0.5-1.6,0.5-2.6C43,55.6,42.4,54.1,41.3,53.2z"/>
		<path d="M69.5,45.8c-1.3,0-2.4,0.2-3.2,0.7c-0.8,0.4-1.5,1-2.1,1.6c-0.5,0.7-0.9,1.3-1.1,2.1
			c-0.2,0.7-0.3,1.4-0.4,1.9H76c-0.2-2.1-0.9-3.6-1.9-4.7C73.2,46.3,71.5,45.8,69.5,45.8z"/>
		<path d="M50,0C22.4,0,0,22.4,0,50s22.4,50,50,50s50-22.4,50-50S77.6,0,50,0z M61.1,32h16.5v4H61.1V32z M50.8,63.5
			c-0.8,1.5-1.9,2.7-3.2,3.7c-1.4,1-2.9,1.7-4.6,2.1c-1.7,0.5-3.5,0.7-5.3,0.7H17.8V29.2H37c2,0,3.7,0.2,5.3,0.5s3,0.9,4.1,1.7
			c1.1,0.8,2,1.8,2.7,3.1c0.6,1.3,0.9,2.9,0.9,4.8c0,2.1-0.5,3.8-1.4,5.1c-0.9,1.4-2.3,2.5-4.2,3.4c2.5,0.7,4.4,2,5.6,3.8
			c1.2,1.8,1.8,4,1.8,6.5C52,60.2,51.6,62,50.8,63.5z M84.1,57.2H62.8c0,2.3,0.8,4.5,2,5.7c1.2,1.2,3,1.8,5.2,1.8
			c1.6,0,3.1-0.4,4.2-1.2c1.2-0.8,1.9-1.7,2.2-2.6h7.1c-1.1,3.6-2.9,6.1-5.3,7.6c-2.3,1.5-5.2,2.3-8.6,2.3c-2.3,0-4.4-0.4-6.3-1.1
			c-1.9-0.8-3.4-1.8-4.8-3.2c-1.3-1.4-2.3-3-3-4.9s-1.1-4-1.1-6.3c0-2.2,0.4-4.3,1.1-6.2c0.7-1.9,1.8-3.6,3.1-4.9
			c1.3-1.4,2.9-2.5,4.8-3.3s3.9-1.2,6.2-1.2c2.5,0,4.7,0.5,6.6,1.5s3.4,2.3,4.6,3.9c1.2,1.6,2.1,3.5,2.6,5.6
			C84.1,52.7,84.3,54.9,84.1,57.2z"/>
	</g>

</svg>


		</a>
  </li>	
	<li>
    <a href="https://www.linkedin.com/in/mark-hawkins-29918641" target="_blank">
    
    <svg className="social-link" version="1.1" x="0px" y="0px" viewBox="0 0 100 100">
<path d="M50,0C22.4,0,0,22.4,0,50s22.4,50,50,50s50-22.4,50-50S77.6,0,50,0z M36,75.3c-3.5,0-7,0-10.5,0
	c0-11.2,0-22.4,0-33.6c0-0.1,0-0.2,0.1-0.2c3.5,0,7,0,10.5,0C36,52.7,36,64,36,75.3z M27.3,35.9c-1.6-1.1-2.9-3.4-2.6-6.1
	c0.3-2,1.7-3.7,3.2-4.5c0.5-0.3,1.2-0.5,2-0.5c4-0.5,7,2.3,7,6.1C36.8,35.5,31.5,38.7,27.3,35.9z M75.4,75.3c-3.5,0-7,0-10.5,0
	c0-3.8,0-7.8,0-12.1c0-5.1,0.7-11-2.8-12.8c-1.7-0.9-4-0.6-5.5,0c-3.8,1.7-3.5,7.1-3.5,13c0,4.1,0,8.4,0,11.9c-3.5,0-7,0-10.5,0
	c0-11.3,0-22.6,0-33.8c3.4,0,6.7,0,10.1,0c0,1.5,0,3.1,0,4.6c0.4-0.3,0.5-0.7,0.8-1.1c1.8-2.4,5-4.4,9.1-4.4c5.2,0,8.9,1.8,10.8,5.1
	c2,3.5,2,8.4,2,13.9C75.4,64.7,75.4,70.3,75.4,75.3z"/>
</svg>


	</a>
</li>		
</ul>



</div>
<div className="sect-3">
  <div className="footer-cta-wrap"><NavLink className="footer-nav-link" to="/archive">File Archive</NavLink></div>
</div>
</div> 

      <div className="credits-window">
		<strong>Credits</strong>
        <p className="thank-you">Resource credits and thanks to the original authors.</p>
		

	  </div>
      <div className="copyright">&copy; {new Date().getFullYear()}, MarkHawkinsDesigns | <span className="credit-info">Credits</span> | 
	  <a href="https://react.dev" target="_blank" className="react-link">Built with React</a></div>
</footer>
  
  );
};

export default Footer;
